<template>
  <section>
    <div class="row mb-4">
      <button :class="['btn', 'btn-secondary', { 'active': 'phone' == cl }]" @click="setRT('phone')">
        <i class="fas fa-phone icon"></i>
      </button>

      <button :class="['btn', 'btn-secondary', { 'active': 'tables' == cl }]" @click="setRT('tables')">
        <i class="fas fa-table icon"></i>
      </button>

      <button :class="['btn', 'btn-secondary', { 'active': 'toggle' == cl }]" @click="setRT('toggle')">
        <i class="fas fa-reply icon"></i>
      </button>
    </div>

    <div class="row" v-show="toggleRealtime">
      <RealtimePhone :conSocket="connection" :class="[{ 'toggle-el': !toggleRealtime }]" />
    </div>

    <div class="row" v-show="!toggleRealtime">
      <RtmCallDetailsTable :conSocket="connection"></RtmCallDetailsTable>
      <RtmUsersDetailsTable :conSocket="connection"></RtmUsersDetailsTable>
    </div>

  </section>
</template>

<script>
import RealtimePhone from "./RealtimePhone.vue";
import RtmCallDetailsTable from "./components/RealtimeCallDetailsTable.vue";
import RtmUsersDetailsTable from "./components/RealtimeUsersDetailsTable.vue";
import { io } from "socket.io-client";
const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
const rtmPort = process.env.APP_PORT || 3003;
const conSocket = io(`${location.protocol}//${location.hostname}:${rtmPort}/realtimeModule`, {
    query: {
        source: "RealtimeApp",
        exten: user.getExtension()
    }
})

// const conSocket = parsedTelefone ? io.connect(`${location.protocol}//${location.hostname}:${rtmPort}/realtimeModule`, {
//   query: {
//     realtimeApp: 42
//   }
// }) : { on: () => { }, emit: () => { } };

export default {
  name: "RealtimeApp",
  components: {
    RealtimePhone,
    RtmCallDetailsTable,
    RtmUsersDetailsTable
  },
  data() {
    return {
      toggleRealtime: true,
      intervalId: "",
      cl: "phone",
      connection: {
        on: () => { },
        emit: () => { }
      },
      queues: []
    };
  },
  created() {
    this.connection = conSocket;
    if (this.cl == "toggle") {
      this.intervalId = setInterval(() => {
        this.toggleRealtime = !this.toggleRealtime;
      }, 15000);
    }
  },
  methods: {
    setRT(style) {
      this.cl = style;
      clearInterval(this.intervalId);

      if (style == "phone") {
        return (this.toggleRealtime = true);
      }

      if (style == "tables") {
        return (this.toggleRealtime = false);
      }

      if (style == "toggle") {
        this.intervalId = setInterval(() => {
          this.toggleRealtime = !this.toggleRealtime;
        }, 15000);
      }
    },
  },
};
</script>

<style scoped>
.toggle-el {
  display: none;
}

.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>